import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.jsx';
import { aplicarTemaInicial } from './shared/ui/tema.js';
import './index.css';

// Antes del primer pintado para que no parpadee el tema claro en cada recarga.
aplicarTemaInicial();

/**
 * Punto de entrada.
 *
 * `StrictMode` está porque en desarrollo monta cada componente dos veces, y eso
 * destapa de inmediato efectos que no limpian bien (suscripciones, timers). Es
 * incómodo mientras se escribe y deja de serlo cuando un componente muta algo
 * que no debería y nadie sabe de dónde salía el segundo estado.
 */
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
